import { render } from "./ListUser.vue?vue&type=template&id=ca56f352"
import script from "./ListUser.vue?vue&type=script&lang=js"
export * from "./ListUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ibrahimisa/Documents/Work/HibSoft/Projects/Frontier-Systems/Projects/geep-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__